<script setup lang="ts">
import { ref } from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { useAuthStore } from '../stores/auth.store'

const username = ref('')
const password = ref('')
const errorMessage = ref('')

async function doLogin() {
    const authStore = useAuthStore();
    return authStore.login(username.value, password.value)
        .catch(error => errorMessage.value = error);
}
</script>
<template>
    <div class="flex justify-center items-center h-full w-full">
        <form @submit.prevent="doLogin" class="w-96 sm-w-80 p-2 flex flex-col gap-4 ">
            <img src="../assets/images/brightside-logo.svg" alt="Brightside" class="w-full" />
            <InputText v-model="username" type="text" placeholder="Username" required autofocus class="dark:bg-black"/>
            <InputText v-model="password" type="password" placeholder="Password"  required class="dark:bg-black" />
            <Button type="submit" label="Login" />
            <p v-if="errorMessage" class="text-red-500">{{ errorMessage }}</p>
        </form>
    </div>
</template>